export default {
  getPaises: state => state.paises,
  getProceso: state => state.proceso,
};
